import { GALLERY } from "../../../mocks/mockContent";
import Reveal from "../../../components/feature/Reveal";

export default function Gallery() {
  return (
    <section aria-label="每日精选图鉴" className="border-t hairline bg-background-50">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex items-end justify-between">
          <div>
            <p className="flex items-center gap-2 text-sm font-semibold tracking-wide text-primary-700">
              <i className="ri-image-2-line" aria-hidden="true"></i>
              视觉瓜田
            </p>
            <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">每日精选图鉴</h2>
          </div>
          <p className="hidden max-w-xs text-right text-sm leading-6 text-foreground-500 sm:block">
            不只刷文字，也看好图。名场面、穿搭、花絮与追剧日历，一张图读懂一个瓜。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {GALLERY.map((g, i) => (
            <Reveal key={g.title} delay={(i % 3) * 90}>
              <figure className="group relative cursor-pointer overflow-hidden rounded-2xl">
                <img
                  src={g.cover}
                  alt={g.title}
                  className="h-60 w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent"></div>
                <figcaption className="absolute inset-x-0 bottom-0 flex items-center justify-between gap-2 p-4">
                  <span className="font-display text-base font-semibold text-background-50">{g.title}</span>
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-background-50/90 text-primary-700">
                    <i className="ri-arrow-right-up-line" aria-hidden="true"></i>
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}